import { StringData } from "../.."
import { StringContext } from "../../core/StringContext"
import { StringModule } from "../../core/StringModule"

/**
 * Tracker module that shows current scroll position and direction.
 * Displays a fixed label in the corner of the screen for debugging.
 */
export class StringPositionTracker extends StringModule {
  private displayElement!: HTMLDivElement

  constructor(context: StringContext) {
    super(context)
    this._type = 2
  }

  /**
   * Called on start — creates the DOM element for position display.
   */
  onInit(): void {
    this.createDisplayElement()
  }

  /**
   * Called on scroll — updates scroll position and direction symbol.
   */
  onScroll(data: StringData): void {
    const current = data.scroll.current
    const target = data.scroll.target

    const direction = current < target ? "↓" : current > target ? "↑" : "-"

    this.displayElement.setAttribute("data-dir", direction)
    this.displayElement.setAttribute("data-val", `${Math.round(current)}`)
  }

  /**
   * Removes display element from DOM.
   */
  destroy(): void {
    this.displayElement.remove()
  }

  /**
   * Creates and styles the floating position indicator.
   */
  private createDisplayElement(): void {
    const el = document.createElement("div")

    Object.assign(el.style, {
      position: "fixed",
      bottom: "10px",
      left: "10px",
      backgroundColor: "#000",
      color: "#fff",
      border: "1px solid rgba(255,255,255,0.2)",
      padding: "5px 8px",
      fontSize: "12px",
      fontFamily: "monospace",
      zIndex: "1000",
      pointerEvents: "none",
    })

    el.setAttribute("data-dir", "-")
    el.setAttribute("data-val", "0")
    document.body.appendChild(el)

    // Inject dynamic CSS if needed
    const style = document.createElement("style")
    style.innerHTML = `
      div[data-dir][data-val]::before {
        content: attr(data-dir) ' Top: ' attr(data-val) 'px';
      }
    `
    document.head.appendChild(style)

    this.displayElement = el
  }
}
